import { createSlice } from '@reduxjs/toolkit';

export const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    isLoggedIn: false,
    isMenuIsOpened: false,
    isLoading: true,
    user: {
      id: "",
      Id:"",
      username: "",
      Username: ""
    }
  },
  reducers: {
    toggleLogin: (state) => {
      if (state.isLoggedIn) {
        state.isLoggedIn = false;
      } else {
        state.isLoggedIn = true;
      }
    },
    setLoginStatus: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    setMenuOpenedState: (state, { payload }) => {
      state.isMenuIsOpened = payload;
    },
    setIsLoadingTo: (state, action) => {
      state.isLoading = action.payload;
    },
    setUserTo:(state ,{payload}) => {
      state.user = payload.data;
    }
  },
});

export const {
  toggleLogin,
  setLoginStatus,
  setMenuOpenedState,
  setIsLoadingTo,
  setUserTo,
} = adminSlice.actions;
export default adminSlice.reducer;
